import React from "react";
import DiagnosticHeader from "components/DiagnosticHeader";
import Timeline from "components/Timeline";
import ProgressIndicator from "../ProgressIndicator";

const GameHeader = ({ handleGoBack, eleve, current, data, randomeImage, studentDemo }) => (
    <div className="flex flex-col">
        <Header handleGoBack={handleGoBack} eleve={eleve} studentDemo={studentDemo} data={data} />
        <Timeline data={data} />
        <ProgressIndicator current={current} data={data?.data} randomeImage={randomeImage} />
    </div>
);

const Header = ({ handleGoBack, eleve, studentDemo, data }) => (
    <DiagnosticHeader
        onBack={handleGoBack}
        studentDemo={studentDemo}
        matiere={data?.type ?? "Mathematique"}
    />
);

export default GameHeader;
